import { postJson, putJson } from '../../../../data/fetchers'
import { SupplierDetail, SupplierDetailWithTemaplate } from './model'

export async function requestCreateSupplier(
  details: SupplierDetailWithTemaplate,
) {
  const result = await postJson<SupplierDetailWithTemaplate>(
    `/selfservices/suppliers`,
    details,
  )

  return result
}

export async function requestUpdateSupplier(
  projectName: string,
  details: SupplierDetail,
) {
  const result = await putJson<SupplierDetail>(
    `/selfservices/suppliers/${projectName}`,
    details,
  )

  return result
}

export async function requestActivateSupplier(supplierId: string) {
  await postJson(`/selfservices/suppliers/${supplierId}/activate`, {})
}

export async function requestDeactivateSupplier(supplierId: string) {
  await postJson(`/selfservices/suppliers/${supplierId}/deactivate`, {})
}
